import { siteFileUrl } from "../siteKit/media/siteMedia";
import { truncateNumber } from "src/domains/shared/utils/truncateNumber";

/**
 * 홈 첫 장면의 드론 — 바로 위에서 본(수직) 실사 사진(회색 몸체)을 두 층으로 나눈 것.
 * 몸체는 프로펠러를 뺀 그림이고, 프로펠러는 2×2 스프라이트다(칸 가운데가 모터 축이라 칸을 돌리면 제자리에서 돈다).
 * 위치·크기 비율은 사진에서 잰 값이다 — 사진을 바꾸면 다시 잰다.
 */
const DRONE_BODY_URL = siteFileUrl("art/drone_body.webp");
const DRONE_PROPS_URL = siteFileUrl("art/drone_props.webp");
/** 몸체 그림의 가로/세로 */
export const DRONE_ASPECT = 1102 / 1074;
/** 화면에서 드론 그림 틀의 가로(px) — 날개 끝까지 포함한 틀. 좁은 화면은 사진 조각(9m)보다 커지지 않게 줄인다 */
export const DRONE_WIDTH_PX = 96;
export const DRONE_WIDTH_PHONE_PX = 76;
/** 사진의 드론은 앞(짐벌 카메라)이 아래를 향한다 — 진행 방향(오른쪽 0°, 아래 90°)에서 이만큼 빼서 돌리면 앞이 가는 쪽을 본다 */
export const DRONE_FORWARD_DEG = 90;
/** 프로펠러 한 바퀴 시간 — 0.1s 는 60Hz 에서 정확히 6프레임/바퀴라 두 날개가 6갈래 별로 멈춰 보인다. 프레임과 맞물리지 않는 값이라야 흐르듯 돈다 */
export const DRONE_ROTOR_SPIN_PERIOD = ".137s";
/** 도는 동안 날개를 비치게 해 실제 사진의 회전 잔상처럼 보이게 한다 */
export const DRONE_ROTOR_SPIN_OPACITY = 0.62;
/** 모터 축 위치(몸체 그림 가로·세로 기준 비율) — 스프라이트 칸 순서와 같다(왼쪽 위·오른쪽 위·왼쪽 아래·오른쪽 아래) */
const DRONE_ROTORS = [
  { x: 0.1624, y: 0.1862 },
  { x: 0.8321, y: 0.1825 },
  { x: 0.1624, y: 0.811 },
  { x: 0.8339, y: 0.8082 },
] as const;
/** 스프라이트 한 칸의 크기(몸체 그림 가로·세로 기준 비율) */
export const DRONE_ROTOR_CELL = { width: 0.559, height: 0.5736 } as const;

const percent = (ratio: number) => `${truncateNumber(ratio * 100, 2)}%`;

/** 무대에 넣는 드론 마크업 — `.heading` 이 진행 방향으로 돌고, `.rt` 넷이 각자 제자리에서 돈다 */
export const droneMarkup = () => {
  const rotors = DRONE_ROTORS.map((rotor, index) => {
    const column = index % 2 === 0 ? "0" : "100%";
    const row = index < 2 ? "0" : "100%";
    return `<span class="rt" style="left:${percent(rotor.x)};top:${percent(
      rotor.y
    )};background-image:url(${DRONE_PROPS_URL});background-position:${column} ${row}"></span>`;
  }).join("");
  return `<div class="drone" aria-hidden="true"><div class="heading"><img src="${DRONE_BODY_URL}" alt="" decoding="async" draggable="false">${rotors}</div></div>`;
};
